import { ILeadPreferences } from "@app/dashboard/dashboard.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const leadPreferencesAdapter: EntityAdapter<ILeadPreferences> = createEntityAdapter<ILeadPreferences>({
	selectId: preferences => preferences.accountId
});